import PolarisIcon from '@/components/_common/PolarisIcon';
import styled from '@emotion/styled';
import { Alert, Button, Grid } from '@mui/material';

interface ErrorWithRetryProps {
  retryFunc: () => void;
  errorMessage?: string;
  retryMessage?: string;
}

const ErrorWithRetry = ({ retryFunc, errorMessage = 'Something went wrong.', retryMessage = 'Retry' }: ErrorWithRetryProps) => {
  return (
    <Grid container flexDirection="row" alignItems="center" justifyContent="center" sx={{ p: 4, pt: 6, pb: 6 }}>
      <StyledAlert severity="error">
        <>
          {errorMessage.length > 0 && errorMessage}
          <Button
            variant="text"
            onClick={retryFunc}
            disableRipple
            startIcon={<PolarisIcon icon="refresh" height={14} />}
            sx={{ ml: 1 }}
            color="error"
          >
            {retryMessage}
          </Button>
        </>
      </StyledAlert>
    </Grid>
  );
};
export default ErrorWithRetry;

const StyledAlert = styled(Alert)`
  border: 1px solid ${({ theme }) => theme.palette.error.main}5a;
  & .MuiAlert-icon {
    align-items: center;
  }
`;
